import * as React from "react";

import "./tools-header.scss";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {isDevXd}         from "@Common/ui-components/debug/is-dev";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown}   from "@fortawesome/free-solid-svg-icons";
import {AiSparklesSvg}   from "@Common/ui-components/ai-banner/ai-sparkles-svg";

export const ToolsHeader = ({isAiEligible, isListingsEligible=false, hasPreviousOrderImages=false, changeListingModal, listingText, isCC, isWizardFlyoutOpen}) => cs(
    consumeContext("userLevels"),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["isDevModeOn", ({isInternalUser}, next) => next(isInternalUser && isDevXd())],
    ["showToolsHeader", ({isDevModeOn}, next) => next(
        (isDevModeOn && isAiEligible) || isListingsEligible || hasPreviousOrderImages
    )],
    ["openFlyout", ({}, next) => next(() => {
        isWizardFlyoutOpen.onChange(true);
        // Need to look into other ways to handle this, this causes scroll bar to dissapear/re-appear & shifts screen
        // document.body.style.overflow = "hidden";
        // document.body.style.height = "100%";
    })],
    ({showToolsHeader, isDevModeOn, openFlyout}) => (
        (showToolsHeader ?  <>
            <div className="nav-header-tl5">
                <div className="page-selection"></div>
                <div className="tools-container">
                    {hasPreviousOrderImages ? <div className="tool previous-order-images"></div> : null}
                    {isDevModeOn && isAiEligible ?
                        <div className="tool ai-tools" onClick={() => openFlyout()}>
                            {AiSparklesSvg()}AI Generation
                        </div>
                    : null}
                    {isListingsEligible ?
                        <div className="tool listing-selection" onClick={changeListingModal.show}>
                            {listingText}
                            <FontAwesomeIcon className="icon" icon={faChevronDown}/>
                        </div>
                    : null}
                </div>
            </div>
            <hr className="nav-header-hr-hp9" />
        </> : null)
    ),
);
